export default "images/车灯开启情况-近光灯.png";